import React from 'react';
import './Photos.scss';

function TextWrapPhoto({ photoData, photoRef }) {
  return (
    <div
      className={photoData.float === 'left' ? 'inline--textWrap left' : 'inline--textWrap right'}
    >
      <div className="inline--textWrap__image">
        <img
          ref={photoRef}
          className="inline--textWrap__image__img"
          src={photoData.imgSrc}
          alt={photoData.caption}
        />
      </div>
      <p className="inline__caption__text inline__caption--textWrap">{photoData.caption}</p>
    </div>
  );
}

export default TextWrapPhoto;
